module.exports = __webpack_public_path__ + "static/media/Untitledq.d96c3de6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Untitledq.png
// module id = 1245
// module chunks = 1